<div class="hvac-progress-container">
    <progress class="progress-bar" max="100" value="{{value}}"></progress>
    <div class="hvac-progress-text"> {{displayValue}}</div>
</div>



